import type { ReactNode } from "react";
import { DashboardPreviewShell } from "./DashboardPreviewShell";

type AuthShellProps = {
  title: string;
  subtitle: string;
  badgeIcon?: string;
  badgeLabel?: string;
  children: ReactNode;
  footer?: ReactNode;
};

export function AuthShell({
  title,
  subtitle,
  badgeIcon = "view_in_ar",
  badgeLabel = "Manual Platform",
  children,
  footer,
}: AuthShellProps) {
  return (
    <div className="auth-shell" data-oid="dxf09s7">
      {/* Live dashboard preview (blurred behind the card) */}
      <DashboardPreviewShell />

      {/* Blurred overlay + centered auth card */}
      <div className="auth-overlay" data-oid="n2uy1pm">
        <div className="auth-card" data-oid="o-d7utl">
          <div className="auth-glow" aria-hidden="true" data-oid="-mu:kpl" />
          <div className="auth-card__content" data-oid="f3mujzh">
            <div className="auth-brand" data-oid="l3xvkpe">
              <div className="auth-brand__icon" data-oid="2id877u">
                <span className="material-symbols-outlined" data-oid="x0dn11e">
                  {badgeIcon}
                </span>
              </div>
              <div className="auth-badge" data-oid="9i6acvf">
                {badgeLabel}
              </div>
              <h1 className="auth-title" data-oid="-o5kok.">
                {title}
              </h1>
              <p className="auth-subtitle" data-oid="1jc95x5">
                {subtitle}
              </p>
            </div>
            {children}
            {footer ? (
              <div className="auth-footer" data-oid="r6a76kq">
                {footer}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
